import Sandbox from '@/components/Sandbox';

import mvpExampleCode from '@/post-helpers/folding-the-dom/code/mvp';
import mvpA11yExampleCode from '@/post-helpers/folding-the-dom/code/mvp-a11y';
import combinedCode from '@/post-helpers/folding-the-dom/code/combined';
import backfaceInitialCode from '@/post-helpers/folding-the-dom/code/backface-initial';
import backfaceHiddenCode from '@/post-helpers/folding-the-dom/code/backface-hidden';

const CODE_FOR_VARIANT = {
  'our-mvp': mvpExampleCode,
  a11y: mvpA11yExampleCode,
  backface: backfaceInitialCode,
  'backface-hidden': backfaceHiddenCode,
  'backface-fixed': backfaceHiddenCode,
  combined: combinedCode,
};

function FoldCodeSnippet({
  variant,
}: {
  variant: keyof typeof CODE_FOR_VARIANT;
}) {
  return (
    <Sandbox
      isLazy
      layout="split"
      splitRatio={0.625}
      minPreviewHeight="12rem"
      dependencies={{
        'styled-components': '6.1.8',
      }}
      files={{
        '/App.js': CODE_FOR_VARIANT[variant],
        '/styles.css': {
          hidden: true,
          code: `
#root > div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
          `,
        },
      }}
    />
  );
}

export default FoldCodeSnippet;
